module.exports = __webpack_public_path__ + "static/media/burger.6292cc1b.usdz";